import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	compose,
	setDisplayName,
} from 'recompose';
import { injectIntl } from 'components';
import { withStyles } from '@material-ui/core/styles';
import { isMobile } from 'helpers/detect-mobile';
import { isEqual } from 'lodash';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListCategories from './ListCategories';

const styles = () => ({
	categoryTitle: {
		fontWeight: 500,
		color: "#000000 !important",
		fontSize: '0.80rem'
	},
	listItem: {
		paddingLeft: 20,
		paddingRight: 10
	}
});

export class CategoryDrawer extends Component {

	static propTypes = {
		classes: PropTypes.shape({}).isRequired,
		products: PropTypes.array,
		categoryFilter: PropTypes.string,
		handleClick: PropTypes.func,
		drawerOpen: PropTypes.bool,
		handleDrawerClose: PropTypes.func,
	};

	shouldComponentUpdate(nextProps, nextState) {
		if (!isEqual(this.props.products, nextProps.products) || this.props.categoryFilter !== nextProps.categoryFilter || this.props.drawerOpen !== nextProps.drawerOpen) {
			return true;
		}
		return false;
	}

	render() {
		const {
			classes,
			products,
			handleClick,
			categoryFilter,
			drawerOpen,
			handleDrawerClose,
		} = this.props;
		debugger;
		return (
			isMobile ? (
				<Drawer
					anchor="right"
					open={drawerOpen}
				>
					<div>
						<IconButton onClick={handleDrawerClose}>
							<ChevronRightIcon />
						</IconButton>
					</div>
					<Divider />
					<List>
						<ListItem
							button
							onClick={handleClick}
							key={"all"}

						>
							<ListItemText
								classes={{ primary: classes.categoryTitle }}
								primary={"All"} />
						</ListItem>
						<ListCategories
							products={products}
							categoryFilter={categoryFilter}
							handleClick={handleClick}
						/>
					</List>
				</Drawer>
			) : (
					<div className="drawer">
						<ListItem
							button
							onClick={handleClick}
							key={"all"}
							classes={{gutters: classes.listItem}}
						>
							<ListItemText
								classes={{ primary: classes.categoryTitle }}
								primary={"All"} />
						</ListItem>
						<div>
							<ListCategories
								products={products}
								categoryFilter={categoryFilter}
								handleClick={handleClick}
							/>
						</div>
					</div>
				)
		);
	}
}

export default compose(
	setDisplayName('CategoryDrawer'),
	withStyles(styles),
	injectIntl,
)(CategoryDrawer);